import { render, staticRenderFns } from "./offline_aftersale_list.vue?vue&type=template&id=c51fd18a&scoped=true"
import script from "./offline_aftersale_list.vue?vue&type=script&lang=js"
export * from "./offline_aftersale_list.vue?vue&type=script&lang=js"
import style0 from "./offline_aftersale_list.vue?vue&type=style&index=0&id=c51fd18a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51fd18a",
  null
  
)

export default component.exports